// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.billingCard_tNMOo {
    height : fit-content;
}

.billingBreakdownCard_eJwP5 {
    height : fit-content;
    flex : 1;
}

.container_CwxUR {
    max-height: 300px;
}

.billingLink_qVug5 {
    display: inline-block !important;
}

.percentageContainer_DZb9k {
    display: flex !important;
    flex-direction: row !important;
}

.percentageDetail_upKRu {
    display: inline;
}

.grid_g1XzW {
    display: grid;
    grid-template-columns: auto auto;
    column-gap: 0;
    row-gap: var(--size-padLarge);
}

.billingValue_Ft86m {
    border-bottom: 1px solid var( --color-base100 );
    padding-bottom: var( --size-padMedium );
}

@media ( max-width: 767px ) {
    .billingCard_tNMOo {
        margin-top : 16px !important;
    }
    .billingCardPane_hRByS {
        border-bottom: none !important;
    }
    .body_ZGxKz {
        flex-direction: column !important;
        align-items : stretch !important;
    }
    .cardBody_XeknT {
        border-bottom: 1px solid var(--color-base100);
        padding: var(--size-padLarge) var(--size-padLarge) var(--size-padLarge) 0!important;
        margin: 0px !important;
    }
    .mobileheader_vZfFh {
        flex-direction: row !important;
        justify-content: space-between !important;
        margin: 0px !important;
    }
    .billingValue_Ft86m {
        margin : 0px !important;
    }
}`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/dashboard/viewer/billing/Billing.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;IACpB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,+CAA+C;IAC/C,uCAAuC;AAC3C;;AAEA;IACI;QACI,4BAA4B;IAChC;IACA;QACI,8BAA8B;IAClC;IACA;QACI,iCAAiC;QACjC,gCAAgC;IACpC;IACA;QACI,6CAA6C;QAC7C,mFAAmF;QACnF,sBAAsB;IAC1B;IACA;QACI,8BAA8B;QAC9B,yCAAyC;QACzC,sBAAsB;IAC1B;IACA;QACI,uBAAuB;IAC3B;AACJ","sourcesContent":[".billingCard {\n    height : fit-content;\n}\n\n.billingBreakdownCard {\n    height : fit-content;\n    flex : 1;\n}\n\n.container {\n    max-height: 300px;\n}\n\n.billingLink {\n    display: inline-block !important;\n}\n\n.percentageContainer {\n    display: flex !important;\n    flex-direction: row !important;\n}\n\n.percentageDetail {\n    display: inline;\n}\n\n.grid {\n    display: grid;\n    grid-template-columns: auto auto;\n    column-gap: 0;\n    row-gap: var(--size-padLarge);\n}\n\n.billingValue {\n    border-bottom: 1px solid var( --color-base100 );\n    padding-bottom: var( --size-padMedium );\n}\n\n@media ( max-width: 767px ) {\n    .billingCard {\n        margin-top : 16px !important;\n    }\n    .billingCardPane {\n        border-bottom: none !important;\n    }\n    .body {\n        flex-direction: column !important;\n        align-items : stretch !important;\n    }\n    .cardBody {\n        border-bottom: 1px solid var(--color-base100);\n        padding: var(--size-padLarge) var(--size-padLarge) var(--size-padLarge) 0!important;\n        margin: 0px !important;\n    }\n    .mobileheader {\n        flex-direction: row !important;\n        justify-content: space-between !important;\n        margin: 0px !important;\n    }\n    .billingValue {\n        margin : 0px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"billingCard": `billingCard_tNMOo`,
	"billingBreakdownCard": `billingBreakdownCard_eJwP5`,
	"container": `container_CwxUR`,
	"billingLink": `billingLink_qVug5`,
	"percentageContainer": `percentageContainer_DZb9k`,
	"percentageDetail": `percentageDetail_upKRu`,
	"grid": `grid_g1XzW`,
	"billingValue": `billingValue_Ft86m`,
	"billingCardPane": `billingCardPane_hRByS`,
	"body": `body_ZGxKz`,
	"cardBody": `cardBody_XeknT`,
	"mobileheader": `mobileheader_vZfFh`
};
export default ___CSS_LOADER_EXPORT___;
